/* eslint-disable @typescript-eslint/no-explicit-any */
import apiClient, { IresponseData, IresponseDataPaginated } from "@/lib/api";

export enum EMessageLogStatus {
  SENT = "SENT",
  FAILED = "FAILED",
}

export interface MessageLog {
  id: number;
  clientId: number;
  ruleId: number | null;
  templateId: number | null;
  status: EMessageLogStatus;
  errorMessage?: string | null;
  createdAt: string;
  sentAt: string;
  client?: { id: number; name: string; phone?: string } | null;
  template?: { id: number; name: string; type: string } | null;
  rule?: { id: number; name: string; templateId?: number } | null;
}

export interface MessageLogFilters {
  clientId?: number;
  ruleId?: number;
  status?: EMessageLogStatus;
  page?: number;
  limit?: number;
}

export interface SendManualMessageRequest {
  templateId: number;
  clientId: number;
}

function removeEmptyFields<T extends Record<string, any>>(obj: T): Partial<T> {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    if (value !== "" && value !== null && value !== undefined) {
      acc[key] = value;
    }
    return acc;
  }, {} as any);
}

export const messageLogService = {
  async getAll(
    filters?: MessageLogFilters,
  ): Promise<IresponseDataPaginated<MessageLog[]>> {
    try {
      const cleanFilters = filters ? removeEmptyFields(filters) : {};
      const response = await apiClient.get<
        IresponseDataPaginated<MessageLog[]>
      >("/message-logs", { params: cleanFilters });
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.message ||
          "Error al obtener el historial de mensajes. Por favor, intenta de nuevo.",
      );
    }
  },

  async sendManual(
    data: SendManualMessageRequest,
  ): Promise<IresponseData<MessageLog>> {
    try {
      const response = await apiClient.post<IresponseData<MessageLog>>(
        "/message-logs/send-manual",
        data,
      );
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.message ||
          "Error al enviar el mensaje. Por favor, intenta de nuevo.",
      );
    }
  },
};
